import { CustomerTableData } from '@/services/models/GupStatistics'
import { GupbridgeService } from '@/services'
import { EnumTokenType } from '@/common/models/enum'
import _ from 'lodash'
import Branch from '@/services/models/GupBridge/Branch'
import GupBridgeTokenRsp from '@/services/models/GupBridge/GupBridgeTokenRsp'

const gupbridgeService = new GupbridgeService()

export default {
  state: {
    customerTableData: [] as CustomerTableData[],
    customerTableCount: 0,
    todayVisitorsCnt: null,
    yesterdayVisitorsCnt: null,
    lastWeekVisitorsCnt: null,
    lastMonthVisitorsCnt: null,
    totalVisitorsCnt: null,
    pointTokenList: [] as any[],
    courseTokenList: [] as any[]
  },

  getters: {
    customerTableData: (state: any) => state.customerTableData,
    customerTableCount: (state: any) => state.customerTableCount,
    todayVisitorsCnt: (state: any) => state.todayVisitorsCnt,
    yesterdayVisitorsCnt: (state: any) => state.yesterdayVisitorsCnt,
    lastWeekVisitorsCnt: (state: any) => state.lastWeekVisitorsCnt,
    lastMonthVisitorsCnt: (state: any) => state.lastMonthVisitorsCnt,
    totalVisitorsCnt: (state: any) => state.totalVisitorsCnt,
    pointTokenList: (state: any) => state.pointTokenList,
    courseTokenList: (state: any) => state.courseTokenList,
    pointContractList: (state: any) => {
      const contractList: any = []
      for (const ct of ['issueContracts', 'redeemContracts']) {
        contractList.push(..._.flatMap(state.pointTokenList, (token) => _.get(token, ct, [])))
      }
      return contractList
    },
    pointMerchantList: (state: any, getters: any) => {
      const ownedMerchant = _.find(state.pointTokenList, (token: GupBridgeTokenRsp) => {
        return token.owned
      })
      let merchantList: Branch[] = [
        { address: ownedMerchant.ownerAddress, name: ownedMerchant.ownerName }
      ]
      merchantList = _.uniqBy(
        _.concat(
          merchantList,
          _.compact(
            _.flatMap(getters.pointContractList, (contract: any) => {
              return contract.branches
            })
          )
        ),
        'address'
      )
      return merchantList
    }
  },

  mutations: {
    initialCustomerTableData(state: any) {
      state.customerTableData = [] as CustomerTableData[]
    },
    setCustomerTableData(state: any, customerTableData: CustomerTableData[]) {
      state.customerTableData = customerTableData
    },
    setCustomerTableCount(state: any, customerTableCount: number) {
      state.customerTableCount = customerTableCount
    },
    setVisitorsCnt(
      state: any,
      VisitorsCnt: {
        todayVisitorsCnt: number
        yesterdayVisitorsCnt: number
        lastWeekVisitorsCnt: number
        lastMonthVisitorsCnt: number
        totalVisitorsCnt: number
      }
    ) {
      const {
        todayVisitorsCnt,
        yesterdayVisitorsCnt,
        lastWeekVisitorsCnt,
        lastMonthVisitorsCnt,
        totalVisitorsCnt
      } = VisitorsCnt
      state.todayVisitorsCnt = todayVisitorsCnt
      state.yesterdayVisitorsCnt = yesterdayVisitorsCnt
      state.lastWeekVisitorsCnt = lastWeekVisitorsCnt
      state.lastMonthVisitorsCnt = lastMonthVisitorsCnt
      state.totalVisitorsCnt = totalVisitorsCnt
    },
    setPointTokenList(state: any, pointTokenList: any) {
      state.pointTokenList = pointTokenList
    },
    setCourseTokenList(state: any, courseTokenList: any) {
      state.courseTokenList = courseTokenList
    }
  },

  actions: {
    async getCustomerList({ commit }: { commit: any }, param: any) {
      const resp = await gupbridgeService.getCustomer(param)
      commit('setCustomerTableData', resp.data)
      commit('setCustomerTableCount', resp.headers['x-total-count'])
    },
    async getVisitorsCnt({ getters, commit }: { getters: any; commit: any }) {
      if (
        getters.todayVisitorsCnt === null ||
        getters.yesterdayVisitorsCnt === null ||
        getters.lastWeekVisitorsCnt === null ||
        getters.lastMonthVisitorsCnt === null ||
        getters.totalVisitorsCnt === null
      ) {
        const res = await gupbridgeService.getVisitorMetrics()
        const todayVisitorsCnt = res.data.today
        const yesterdayVisitorsCnt = res.data.yesterday
        const lastWeekVisitorsCnt = res.data.lastWeek
        const lastMonthVisitorsCnt = res.data.lastMonth
        const totalVisitorsCnt = res.data.total
        commit('setVisitorsCnt', {
          todayVisitorsCnt,
          yesterdayVisitorsCnt,
          lastWeekVisitorsCnt,
          lastMonthVisitorsCnt,
          totalVisitorsCnt
        })
      }
    },
    async getPointTokenList({ commit, state }: { commit: any; state: any }) {
      if (state.pointTokenList.length > 0) {
        return
      }
      const resp = await gupbridgeService.getTokens(EnumTokenType.Point)
      commit('setPointTokenList', resp.data)
    },
    async getTokenList({ commit, state }: { commit: any; state: any }) {
      if (state.pointTokenList.length === 0) {
        const resp = await gupbridgeService.getTokens(EnumTokenType.Point)
        commit('setPointTokenList', resp.data)
      }
      if (state.courseTokenList.length === 0) {
        const resp = await gupbridgeService.getTokens(EnumTokenType.Course)
        commit('setCourseTokenList', resp.data)
      }
    }
  },

  namespaced: true
}
